import { CoreCapsuleWithAccount, PoolCapsuleWithAccount } from 'entities'
import { BigNumber } from 'ethers'
import { AssetInfo } from 'types'
import { ACTION_TYPES } from '../borrowActions'
import { getBorrowFutureValues } from './getBorrowFutureValues'
import { getDepositFutureValues } from './getDepositFutureValues'
import { IFutureValues, NULL_FUTURE_VALUES } from './IFutureValues'

export function getFutureValues(
  coreCapsule: CoreCapsuleWithAccount,
  poolCapsule: PoolCapsuleWithAccount,
  selectedAction: ACTION_TYPES,
  borrowAsset: AssetInfo,
  inputAmount?: BigNumber,
): IFutureValues {
  if (!inputAmount) {
    return NULL_FUTURE_VALUES
  }

  let res: IFutureValues

  switch (selectedAction) {
    case ACTION_TYPES.DEPOSIT: {
      res = getDepositFutureValues(coreCapsule, poolCapsule, borrowAsset, inputAmount)
      break
    }
    case ACTION_TYPES.BORROW: {
      res = getBorrowFutureValues(coreCapsule, poolCapsule, borrowAsset, inputAmount)
      break
    }
    case ACTION_TYPES.WITHDRAW: {
      res = getDepositFutureValues(coreCapsule, poolCapsule, borrowAsset, inputAmount.mul(-1))
      break
    }
    case ACTION_TYPES.REPAY: {
      res = getBorrowFutureValues(coreCapsule, poolCapsule, borrowAsset, inputAmount.mul(-1))
      break
    }
    default: {
      return NULL_FUTURE_VALUES
    }
  }

  return limitToZero(res)
}

/**
 * Some numbers may be negative, so we limit them to zero.
 */
function limitToZero(futureValues: IFutureValues): IFutureValues {
  return Object.keys(futureValues).reduce((prev, curr) => {
    if (!futureValues[curr]) {
      return {
        ...prev,
        [curr]: futureValues[curr],
      }
    }

    return {
      ...prev,
      [curr]: futureValues[curr].isNegative() ? BigNumber.from(0) : futureValues[curr],
    }
  }, NULL_FUTURE_VALUES)
}
